fourToldApp.controller('profileCntrl', function (xmppAuth, $http, services, esb, $location, $scope, $rootScope, $cookieStore, $cookies, $localStorage, $mdDialog, $window, $filter, $mdToast, theme) {
    $scope.user = services.user.getData();
    $scope.user.photo = services.user.getPhoto();
    $scope.theme = theme.getTheme();
    var addressList = $scope.user.entity.entityAddress;
    $scope.homeAddress = $scope.user.entity.address.addressLine1;

    $scope.activatedConfigureQuestions = $window.sessionStorage.getItem('activatedConfigureQuestions') === "true";

    for (address of addressList) {
        if(address.addressLabel == "HOME") {
            $scope.homeAddress = address.addressLine1;
        }
    }


    $scope.signature = function(ev) {
      var confirm = $mdDialog.show({
          controller: 'signatureCntrl',
          templateUrl: './views/dashboard/signature.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          fullscreen: true,
      }).then(function(answer) {
        }, function() {
            $scope.disabledBtn = false;
      });
    };

    $scope.msgToast = function(message, type){
      $mdToast.show(
          $mdToast.simple()
          .textContent(message)
          .position('top')
          .action('Ok')
          .theme(type)
          .hideDelay(2000)
      );
    };

    $scope.questionsDialog = function(ev) {
      if($window.localStorage.getItem('access_token1')) {
        $scope.quentions = services.configuration_securityQuentionsRequest('bearer ' + $window.localStorage.getItem('access_token1')).getQuestions({}, {},  function(response) {
          if(response.code === 2 || response.data.length === 0){
           
          } else {

            response["tipo"] = "answer";
            $window.localStorage.setItem('dataQuentions', JSON.stringify(response));
            $mdDialog.show({
              locals:{dataToPass: response},
              templateUrl: 'views/dashboard/security_questions.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              controller: 'quentionsCntrl',
              clickOutsideToClose:false
            }).then(function(answer) {
              if(answer.result) {
                $scope.signature();
              } else {                
                var messageError = "";
                switch (answer.errorCode) {
                    case -59:
                        messageError = "Las respuestas son incorrectas";
                        break;
                    case -89:
                        messageError = "Intentos máximos fallidos, por favor contacte a soporte técnico";
                        break;
                    default:
                        messageError = errorMessage;
                        break;
                }
                $scope.msgToast(messageError, "error-toast");
              }

            }, function() {
                 
          }); ;
          }
        });
      }
    };

});
